export default __webpack_public_path__ + "static/article-whats-your-interior-design-style-4ccfc69c5be2d058a3a4144e50f221b0.jpg";